import { render } from "./Complete.vue?vue&type=template&id=1de22906&scoped=true"
import script from "./Complete.vue?vue&type=script&lang=js"
export * from "./Complete.vue?vue&type=script&lang=js"

import "./Complete.vue?vue&type=style&index=0&id=1de22906&scoped=true&lang=css"
import "./Complete.vue?vue&type=style&index=1&id=1de22906&lang=css"

import exportComponent from "C:\\wamp64\\www\\ehaat-ambulance-game\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de22906"]])

export default __exports__